import React from 'react'

import { tokens } from '@news-mono/design-tokens'
import { useAuthActions } from '../../../authentication'
import {
    BodyText,
    Heading,
    StyledCTAWardenButton,
    StyledTextLink,
    TextWrapper,
} from './component.styled'
import { useSelector } from 'react-redux'
import { AppState, SignupOrigin } from 'web-common'

type LoginContentProps = {
    text: CTAText
    componentOrigin?: SignupOrigin
}

export const LoginContent = ({ text, componentOrigin }: LoginContentProps) => {
    const { onRegisterClick, onLoginClick } = useAuthActions()
    const renditionType =
        useSelector((state: AppState) => state.render.renditionType) === 'app'
            ? 'app'
            : 'web'

    return (
        <>
            <TextWrapper>
                <Heading>{text.title}</Heading>
                <BodyText>{text.body}</BodyText>
            </TextWrapper>

            <StyledCTAWardenButton
                onClick={() => onRegisterClick(componentOrigin, renditionType)}
                backgroundColors={{
                    default:
                        tokens.thenightly.colors.palette.utility.error.default,
                    hover: tokens.thenightly.colors.palette.utility.error.hover,
                }}
                roundEdges={true}
                useWidePadding={true}
            >
                CREATE FREE ACCOUNT
            </StyledCTAWardenButton>

            <BodyText>
                Already have an account?
                <StyledTextLink onClick={onLoginClick}>
                    Log in here
                </StyledTextLink>
            </BodyText>
        </>
    )
}
